import React from 'react';
import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import StepMenu from 'js/components/core/SteppedPage/StepMenu';

export default class SteppedComponent extends PageComponent {
  componentDidUpdate() {
    this.page.gotoStep(this.props['*'] || 0);
  }

  renderPage() {
    const { component: Step, showStepMenu } = this.page.step;
    return (
      <AppContent>
        {showStepMenu && <StepMenu />}
        <Step />
      </AppContent>
    );
  }
}
